// extracted by mini-css-extract-plugin
export default {"container":"BoletimHeader_container__0XuUX","logo":"BoletimHeader_logo__-sdIV","h1":"BoletimHeader_h1__3URte"};